import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IArticle } from 'src/app/models/interfaces/article.interface';

export class ArticleDetailContext extends DefaultDetailContext<IArticle, number> {}
